import React from 'react'

export function TableIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.6155 20C5.15517 20 4.77083 19.8458 4.4625 19.5375C4.15417 19.2292 4 18.8448 4 18.3845V5.6155C4 5.15517 4.15417 4.77083 4.4625 4.4625C4.77083 4.15417 5.15517 4 5.6155 4H18.3845C18.8448 4 19.2292 4.15417 19.5375 4.4625C19.8458 4.77083 20 5.15517 20 5.6155V18.3845C20 18.8448 19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8448 20 18.3845 20H5.6155ZM11.5 14.4038H5V18.3845C5 18.564 5.05767 18.7115 5.173 18.827C5.2885 18.9423 5.436 19 5.6155 19H11.5V14.4038ZM12.5 14.4038V19H18.3845C18.564 19 18.7115 18.9423 18.827 18.827C18.9423 18.7115 19 18.564 19 18.3845V14.4038H12.5ZM11.5 13.4038V8.76925H5V13.4038H11.5ZM12.5 13.4038H19V8.76925H12.5V13.4038ZM5 7.76925H19V5.6155C19 5.436 18.9423 5.2885 18.827 5.173C18.7115 5.05767 18.564 5 18.3845 5H5.6155C5.436 5 5.2885 5.05767 5.173 5.173C5.05767 5.2885 5 5.436 5 5.6155V7.76925Z'
        fill='currentColor'
      />
    </svg>
  )
}
